import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const paypalRoutes: PermissionedRouteObject[] = [
  {
    path: "callback-close",
    async lazy() {
      const { CallbackClose } = await import("./callback-close");
      return { Component: CallbackClose };
    },
  },
];
